import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import postcodeAutoCompleteActions from './postcode-auto-complete-actions'

/*

Simply provides postcode-auto-complete configuration to the wrapped components

*/

const mapStateToProps = (state, initialProps) => ({
    ...initialProps,
    postcodeAutoComplete: state.postcodeAutoComplete
})


const mapDispatchToProps = (dispatch, props) => ({
    actions:{
        ...props.actions,
        postcodeAutoComplete: bindActionCreators( postcodeAutoCompleteActions, dispatch )
    }
})


export const withPostcodeAutoComplete = (Wrapped:React.ComponentClass) => connect(mapStateToProps, mapDispatchToProps)(Wrapped)




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/postcode-auto-complete/index.tsx